import { render, staticRenderFns } from "./SectionHeadline.vue?vue&type=template&id=10210d8a"
import script from "./SectionHeadline.vue?vue&type=script&lang=js"
export * from "./SectionHeadline.vue?vue&type=script&lang=js"
import style0 from "./SectionHeadline.vue?vue&type=style&index=0&id=10210d8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports